import Register from "@/pages/Register";

export default function DeferredIncome() {
  return <Register lockedType="DEFERRED_INCOME" />;
}
